/* Glowy custom behaviour
   1. Collapse long product descriptions behind "Δες περισσότερα"
   2. Free Biodance mask: added to the cart automatically from 49€, removed again below 49€.
      The price is made 0€ by the automatic discount "BIODANCE GIFT" in Shopify. */
(function () {
  /* ---------- 1. Description ---------- */
  function setupDescriptions(root) {
    (root || document).querySelectorAll('.product__block--description:not([data-glowy])').forEach(function (el) {
      el.setAttribute('data-glowy', '');
      if (el.scrollHeight < 260) return;
      el.classList.add('glowy-clamp');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'glowy-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Δες περισσότερα';
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('glowy-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Λιγότερα' : 'Δες περισσότερα';
        if (!open) el.scrollIntoView({ block: 'nearest' });
      });
      el.insertAdjacentElement('afterend', btn);
    });
  }

  /* ---------- 2. Gift ---------- */
  var GIFT = {
    threshold: 7900, // cents
    collection: 'free-biodance',
    prop: '_glowy_gift'
  };
  var busy = false; try { document.head.insertAdjacentHTML('beforeend', '<style>.gift-progress{display:none!important}body:has(cart-drawer[open]) shopify-chat{display:none!important}' + (location.pathname.indexOf('/cart') === 0 ? 'shopify-chat{display:none!important}' : '') + '</style>'); } catch (e) {}
  var lastHadGift = null;

  function store(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function giftVariants() {
    // the theme prints the masks that are physically in stock (never a pre-order one)
    if (Array.isArray(window.GlowyGiftVariants)) return Promise.resolve(window.GlowyGiftVariants);
    var cached = store('glowy_gift_variants');
    if (cached) {
      try { return Promise.resolve(JSON.parse(cached)); } catch (e) {}
    }
    return fetch('/collections/' + GIFT.collection + '/products.json?limit=20')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var ids = [];
        (data.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) { if (v.available) ids.push(v.id); });
        });
        store('glowy_gift_variants', JSON.stringify(ids));
        return ids;
      })
      .catch(function () { return []; });
  }

  function isGift(item) {
    return item.properties && item.properties[GIFT.prop];
  }

  function paidSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return isGift(item) ? sum : sum + (item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
    if (document.body.classList.contains('cart-template')) window.location.reload();
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function money(cents) {
    return (cents / 100).toLocaleString('el-GR', { style: 'currency', currency: 'EUR' });
  }

  // keep the "X€ left for the gift" bar in the side cart in sync after every change
  function renderGiftBar(cart) {
    var paid = paidSubtotal(cart);
    var left = GIFT.threshold - paid;
    var pct = Math.max(0, Math.min(100, Math.round((paid / GIFT.threshold) * 100)));
    var html = left > 0
      ? '<p>Ακόμα <strong>' + money(left) + '</strong> για δώρο μάσκα Biodance</p>'
      : '<p><strong>Η μάσκα Biodance μπήκε δώρο στο καλάθι σου</strong></p>';
    html += '<div class="progress-bar"><div class="progress-fill" style="width:' + (left > 0 ? pct : 100) + '%"></div></div>';
    document.querySelectorAll('.cart-drawer .gift-progress').forEach(function (el) {
      el.innerHTML = html;
      el.classList.toggle('is-done', left <= 0);
    });
    // card vs cash on delivery shipping note
    document.querySelectorAll('.cart-drawer .card-payment-message').forEach(function (el) {
      el.textContent = 'Με κάρτα: δωρεάν αποστολή από 45€ · Αντικαταβολή +1,50€';
    });
  }

  function evaluate(cart) {
    if (!cart || !cart.items) return;
    renderGiftBar(cart);
    if (busy) return;
    var giftLines = cart.items.filter(isGift);
    var hasGift = giftLines.length > 0;
    var qualifies = paidSubtotal(cart) >= GIFT.threshold;

    // the customer removed the gift themselves: respect it until the cart drops below 49€
    if (lastHadGift === true && !hasGift && qualifies) store('glowy_gift_declined', '1');
    if (!qualifies) store('glowy_gift_declined', null);
    lastHadGift = hasGift;

    if (qualifies && !hasGift && !store('glowy_gift_declined')) {
      busy = true;
      giftVariants().then(function (ids) {
        if (!ids.length) { busy = false; return; }
        var props = {};
        props[GIFT.prop] = 'Δώρο';
        return post('/cart/add.js', { items: [{ id: ids[0], quantity: 1, properties: props }] }).then(function (res) {
          busy = false;
          if (res && res.status) {
            // went out of stock meanwhile: re-read the list next time, don't retry in this visit
            store('glowy_gift_variants', null);
            store('glowy_gift_declined', '1');
            lastHadGift = false;
            return;
          }
          lastHadGift = true;
          refreshDrawer();
        });
      }).catch(function () { busy = false; });
      return;
    }

    if (hasGift && (!qualifies || giftLines.length > 1 || giftLines[0].quantity > 1)) {
      busy = true;
      var updates = {};
      giftLines.forEach(function (line, i) {
        updates[line.key] = qualifies && i === 0 ? 1 : 0;
      });
      post('/cart/update.js', { updates: updates }).then(function () {
        lastHadGift = qualifies;
        busy = false;
        refreshDrawer();
      }).catch(function () { busy = false; });
    }
  }

  function checkCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(evaluate)
      .catch(function () {});
  }

  function subscribe() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (data) {
        // some updates carry a partial cart: always read the real one
        setTimeout(checkCart, 50);
      });
      return true;
    }
    return false;
  }

  /* ---------- 3. Back in stock ----------
     The Notify Me app is set to place its button on product-card buttons, so on the product page
     it lands inside the hidden search panel. Move it under the sold-out button of the main product. */
  var NOTE = 'Παραλαμβάνουμε νέο απόθεμα κάθε εβδομάδα. Άφησε το email σου και θα σε ειδοποιήσουμε μόλις έρθει.';

  function placeNotify() {
    var block = document.querySelector('.product__block--buy_buttons');
    if (!block) return false;
    var submit = block.querySelector('.product-form__submit');
    if (!submit || !submit.disabled) {
      block.classList.remove('glowy-soldout');
      return false;
    }
    var btn = document.querySelector('.PRODUCT_PAGE-notify-button');
    if (!btn) return false;
    var holder = block.querySelector('.glowy-notify-wrap');
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'glowy-notify-wrap';
      var note = document.createElement('p');
      note.className = 'glowy-notify-note';
      note.textContent = NOTE;
      holder.appendChild(note);
      (submit.closest('.product-form__buttons') || submit.parentElement).insertAdjacentElement('afterend', holder);
    }
    if (btn.parentElement !== holder) holder.insertBefore(btn, holder.firstChild);
    btn.classList.add('glowy-notify-btn');
    block.classList.add('glowy-soldout');
    return true;
  }

  function setupNotify() {
    if (!document.querySelector('.product__block--buy_buttons')) return;
    placeNotify();
    // the app injects late and re-renders on variant change
    var obs = new MutationObserver(function () {
      var btn = document.querySelector('.PRODUCT_PAGE-notify-button');
      if (btn && !btn.closest('.glowy-notify-wrap')) placeNotify();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-picker, .product__block--variant_picker')) setTimeout(placeNotify, 300);
    });
  }

  function init() {
    setupDescriptions();
    setupNotify();
    if (!subscribe()) {
      var tries = 0;
      var t = setInterval(function () { if (subscribe() || ++tries > 20) clearInterval(t); }, 250);
    }
    checkCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { setupDescriptions(e.target); });
})();
/* Cart: only Apple Pay / Google Pay as express buttons (hide Shop Pay & PayPal); checkout keeps all */
(function(){function f(){document.querySelectorAll('shopify-accelerated-checkout-cart[wallet-configs]').forEach(function(c){try{var w=JSON.parse(c.getAttribute('wallet-configs'));var k=w.filter(function(x){return x.name!=='shop_pay'&&x.name!=='paypal'});if(k.length===w.length)return;var n=document.createElement('shopify-accelerated-checkout-cart');for(var i=0;i<c.attributes.length;i++)n.setAttribute(c.attributes[i].name,c.attributes[i].value);n.setAttribute('wallet-configs',JSON.stringify(k));c.replaceWith(n)}catch(e){}})}f();document.addEventListener('DOMContentLoaded',f);new MutationObserver(f).observe(document.documentElement,{childList:true,subtree:true})})();